import { CreatePasswordUseCase } from '@/application/auth/createPasswordUseCase';
import { LoginUseCase } from '@/application/auth/loginUseCase';
import { LogoutUseCase } from '@/application/auth/logoutUseCase';
import { authApiRepository, warningNotificationService } from '@/infra';
import { authStoreApiRepository } from '@/infra/repositories/authStore.repository';
import { logoutLocalRepository } from '@/infra/repositories/logoutLocal.repository';
import { storeTokenProviderRepository } from '@/infra/repositories/tokenProvider.repository';
import type { TokenProviderRepository } from '@/shared/contracts/tokenProvider.repository';

// variables privadas del módulo
let _loginUseCase: LoginUseCase | null = null;
let _logoutUseCase: LogoutUseCase | null = null;
let _tokenProvider: TokenProviderRepository | null = null;
let _createPassword: CreatePasswordUseCase | null = null;

/**
 * Función que inyecta una instancia de loginUseCase
 * Refactorizada para usar authLoginService (interfaz granular)
 */
export const getLoginUseCase = (): LoginUseCase => {
  if (!_loginUseCase) {
    _loginUseCase = new LoginUseCase(authApiRepository, authStoreApiRepository);
  }
  return _loginUseCase;
};

/**
 * Función que inyecta una instancia de logoutUseCase
 * Centraliza la lógica de logout siguiendo Clean Architecture
 */
export const getLogoutUseCase = (): LogoutUseCase => {
  if (!_logoutUseCase) {
    _logoutUseCase = new LogoutUseCase(
      warningNotificationService,
      logoutLocalRepository,
    );
  }
  return _logoutUseCase;
};

/**
 * Función que inyecta TokenProvider
 * Cumple con DIP - permite acceso a tokens sin violar capas
 */
export const getTokenProvider = (): TokenProviderRepository => {
  if (!_tokenProvider) {
    _tokenProvider = storeTokenProviderRepository;
  }
  return _tokenProvider;
};

export const createPasswordUseCase = (): CreatePasswordUseCase => {
  if (!_createPassword) {
    _createPassword = new CreatePasswordUseCase(authApiRepository);
  }

  return _createPassword;
};

/**
 * Función para resetear las instancias
 */
export const resetAuthContainer = (): void => {
  _loginUseCase = null;
  _logoutUseCase = null;
  _tokenProvider = null;
  _createPassword = null;
};
